import { takeLatest, put, call } from 'redux-saga/effects';
import request from '../../components/Utils/httpHelper';
import * as corporateMasterDataUpload from './action';
import { CORE_API } from '../../config';
import { HTTP_HEADERS, HTTP_HEADERS_FORMDATA, HTTP_RESPONSE_TYPE_ARRAYBUFFER } from '../../constants'
import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE } from "./CorporateMasterTable/constants"

export function* corporateMasterTemplateRequest(action) {
    let requestURL = `${CORE_API}/corporate/master/template/download`;

    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(corporateMasterDataUpload.corporateMasterTemplateSuccess({ data: data.data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(corporateMasterDataUpload.corporateMasterTemplateFailure({ ...err.response, status: "FAILURE" }))
    }
}

export function* corporateMasterTemplate() {
    yield takeLatest(corporateMasterDataUpload.CORPORATE_MASTER_TEMPLATE_REQUEST, corporateMasterTemplateRequest);
}

export function* submitCorporateMasterRequestSaga(action) {
    const formData = new FormData();
    formData.append('corporateMasterExcelFile', action.data.file);
    let requestUrl = "";
    let methodtype = "";
    if (action.data.type === 'add') {
        methodtype = "POST"
        requestUrl = `${CORE_API}/corporate/master/add`;
    }
    if (action.data.type === 'edit') {
        methodtype = "PUT"
        requestUrl = `${CORE_API}/corporate/master/update`;
    }
    try {
        const searchResult = yield call(request, requestUrl, { data: formData, method: methodtype, headers: HTTP_HEADERS_FORMDATA });
        yield put(corporateMasterDataUpload.corporateMasterDataUploadSuccess(searchResult.data));
    } catch (err) {
        console.log(err.response)
        yield put(corporateMasterDataUpload.corporateMasterDataUploadFailure({ ...err.response, status: "FAILURE" }))
    }
}
export function* submitCorporateMasterRequest() {
    yield takeLatest(corporateMasterDataUpload.CORPORATE_MASTER_DATA_UPLOAD, submitCorporateMasterRequestSaga);
}

export function* corporateMasterListSaga(action) {
    const { pageNumber = DEFAULT_PAGE_NUMBER, pageSize = DEFAULT_PAGE_SIZE, filter = {}, sorted = [{ id: "createdAt", desc: true }] } = action.data || {}
    const sortDirection = sorted.desc ? 'desc' : 'asc', sortField = sorted.id || 'createdAt'
    const requestURL = `${CORE_API}/corporate/master/list/${pageNumber}/${pageSize}/sort/${sortField}/${sortDirection}`;
    
      try{
        const response = yield call (request , requestURL,{
            method: 'POST',
            headers: HTTP_HEADERS,
            data: filter
    
        });
    
        yield put(corporateMasterDataUpload.corporateMasterListSuccess(response.data))
    
      }catch(err){
        yield put(
            corporateMasterDataUpload.corporateMasterListFailure(
                err.response?.data || {message:'Failed to fetch Corporate Master list'}
            )
        );
    
      }
}

export function* fetchCorporateMasterList() {
  yield takeLatest(
    corporateMasterDataUpload.CORPORATE_MASTER_LIST_REQUEST,
    corporateMasterListSaga
  );
}


export function* corporateMasterDataExcelRequest(action) {
    let requestURL = `${CORE_API}/corporate/master/list/download`;

    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(corporateMasterDataUpload.corporateMasterDataExcelSuccess({ data: data.data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(corporateMasterDataUpload.corporateMasterDataExcelFailure({ ...err.response, status: "FAILURE" }))
    }
}

export function* corporateMasterDataExcel() {
    yield takeLatest(corporateMasterDataUpload.CORPORATE_MASTER_DATA_EXCEL_REQUEST, corporateMasterDataExcelRequest);
}

function fetchCorporatesAPI() {
    return request(`${CORE_API}/corporate/list/byIdName`, {
        method: "GET"
    });
}

export function* corporateMasterGetCorporatesSaga() {
    try {
        const response = yield call(fetchCorporatesAPI);
        const corporates = response.data.map((c) => ({
            id: c.id,
            name: c.corporateName,
        }));
        yield put(corporateMasterDataUpload.corporateMasterGetCorporatesSuccess(corporates));
    } catch (err) {
        yield put(
            corporateMasterDataUpload.corporateMasterGetCorporatesFailure(
                err.response?.data?.message || err.message || 'Failed to fetch corporates'
            )
        );
    }
}

export function* corporateMasterGetCorporates() {
    yield takeLatest(
        corporateMasterDataUpload.CORPORATE_MASTER_GET_CORPORATES_REQUEST,
        corporateMasterGetCorporatesSaga
    );
}
